import LoginPage from '../../components/auth/LoginPage.vue'
import SignupPage from '../../components/auth/SignupPage.vue'

export default {
  login: {
    title: 'Login Page',
    name: 'login',
    route: '/login',
    component: LoginPage,
    checkAuth: true,
    needAuth: false,
    layoutName: 'auth',
  },
  // signup: {
  //   title: 'Signup Page',
  //   name: 'signup',
  //   route: '/register',
  //   component: SignupPage,
  //   checkAuth: true,
  //   needAuth: false,
  //   layoutName: 'auth',
  // },
}
